import { render, staticRenderFns } from "./tmoDemo350x244.vue?vue&type=template&id=35b2510d&"
import script from "./tmoDemo350x244.vue?vue&type=script&lang=js&"
export * from "./tmoDemo350x244.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports